<template>
  <article class="gs-funnel-card" :class="{ 'is-unpublished': funnel.is_live != 1 }">
    <button
      type="button"
      class="gs-funnel-card__media"
      :aria-label="`Open ${funnel.name} dashboard`"
      @click="sendToDashboard"
    >
      <span
        class="gs-funnel-card__status"
        :class="funnel.is_live == 1 ? 'is-live' : 'is-draft'"
      >
        {{ funnel.is_live == 1 ? 'Live' : 'Not live' }}
      </span>
      <img
        v-if="funnelImage"
        class="gs-funnel-card__image"
        :src="funnelImage"
        :alt="funnel.name"
      />
      <gifts-icon v-else class="gs-funnel-card__placeholder" />
      <span class="gs-funnel-card__manage">
        {{ $t('frontend_groovesell_manage_product_funnel') }}
      </span>
    </button>
    <div class="gs-funnel-card__body">
      <div class="gs-funnel-card__title-row">
        <h3 class="gs-funnel-card__title">{{ funnel.name }}</h3>
        <drop-menu :menu-items="menuItems" dropMenuClass="absolute bottom-0 mt-13 z-40" small></drop-menu>
      </div>
      <p class="gs-funnel-card__meta">
        {{ funnel.all_products ? funnel.all_products.length : 0 }} {{ $t('frontend_products') }}
      </p>
      <funnel-draft-notice v-if="funnel.is_live != 1" @publish="$emit('onPublishFunnel', funnel.id)" />
      <div class="gs-funnel-card__actions">
        <button
          v-for="option in menuItemsIcons"
          :key="option.text"
          type="button"
          class="gs-funnel-card__icon-button"
          :aria-label="option.text"
          :title="option.text"
          @click="option.callback()"
          v-tooltip="option.text"
        >
          <component :is="option.icon" />
        </button>
      </div>
    </div>
  </article>
</template>

<script>
import FunnelDraftNotice from './FunnelDraftNotice.vue';
import GiftsIcon from '@/assets/images/icons/GiftsIcon.svg';
import MegaphoneIcon from '@/assets/images/icons/MegaphoneIcon.svg';
import ToolsIcon from '@/assets/images/icons/ToolsIcon.svg';
import TrophyIcon from '@/assets/images/icons/TrophyIcon.svg';
import HandshakeIcon from '@/assets/images/icons/HandshakeIcon.svg';
import DocumentIcon from '@/assets/images/icons/DocumentIcon.svg';

export default {
  name: 'FunnelGridAsset',
  components: {
    GiftsIcon,
    FunnelDraftNotice,
  },
  props: {
    funnel: {},
  },
  computed: {
    funnelImage() {
      let funnelImage = false;

      if (
        this.funnel.main_product &&
        this.funnel.main_product.checkout_page_options &&
        this.funnel.main_product.checkout_page_options.product_image &&
        this.funnel.main_product.checkout_page_options.product_image != ''
      )
        funnelImage =
          this.funnel.main_product.checkout_page_options.product_image;

      return funnelImage;
    },
    menuItemsIcons() {
      const menuItemsIcons = [];
      menuItemsIcons.push({
        icon: GiftsIcon,
        text: this.$t('frontend_funnels_manage_products'),
        callback: () => this.$emit('onManageProducts', this.funnel.id),
      });
      menuItemsIcons.push({
        icon: MegaphoneIcon,
        text: this.$t('frontend_funnels_affiliate_signup_promo_tools'),
        callback: () => this.$emit('onManagePromotools', this.funnel.id),
      });
      if (this.funnel.main_product_id) {
        menuItemsIcons.push({
          icon: ToolsIcon,
          text: this.$t('forntend_checkout_links'),
          callback: () => this.$router.push({ name: 'productsCheckoutLinks', params: { id: this.funnel.id, product_id: this.funnel.main_product_id } }),
        });
      }
      menuItemsIcons.push({
        icon: TrophyIcon,
        text: this.$t('frontend_leaderboards'),
        callback: () => this.$router.push({ name: 'leader_boards' }),
      });
      menuItemsIcons.push({
        icon: HandshakeIcon,
        text: this.$t('frontend_gduikit_sidebar_manage_affiliates'),
        callback: () => this.$router.push({ name: 'affiliates', query: { funnel_id: this.funnel.id} }),
      });
      menuItemsIcons.push({
        icon: DocumentIcon,
        text: this.$t('frontend_gduikit_sidebar_reports'),
        callback: () => this.$router.push({ name: 'vendor_report', query: { funnel_id: this.funnel.id} }),
      });
      return menuItemsIcons;
    },
    menuItems() {
      const menuItems = [];
      menuItems.push({
        text: this.$t('frontend_funnels_settings'),
        callback: () => this.$emit('onEditFunnel', this.funnel.id),
      });

     
      menuItems.push({
        text: this.$t('frontend_funnels_clone'),
        callback: () => this.$emit('onCloneFunnels', this.funnel.id),
      });
      menuItems.push({
        text: this.$t('frontend_funnels_delete'),
        callback: () => this.$emit('onDeleteFunnels', this.funnel.id),
      });


      return menuItems;
    },
  },
  methods: {
    backgroundImageUrl(url) {
      if (url) {
        return `url("${url}")`;
      }

      return '';
    },
    sendToManageProducts() {
      this.$emit('onManageProducts', this.funnel.id);
    },
    sendToDashboard() {
      this.$router.push({ name: 'funnelDashboard', params: { id: this.funnel.id } });
    },
  },
};
</script>

<style lang="scss">
.gs-funnel-card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 276px;
  margin: 8px 0 14px;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e4e8f1;
  border-radius: 8px;
  box-shadow: 0 14px 32px rgba(31, 37, 72, .07);
  transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
}

.gs-funnel-card:hover {
  border-color: #ffd0d9;
  box-shadow: 0 22px 44px rgba(31, 37, 72, .12);
  transform: translateY(-2px);
}

.gs-funnel-card__media {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 160px;
  padding: 22px;
  color: #ff5b7f;
  background: linear-gradient(180deg, #ffffff 0%, #fbfcff 100%);
  border: 0;
  border-bottom: 1px solid #edf0f6;
  cursor: pointer;
}

.gs-funnel-card__image,
.gs-funnel-card__placeholder {
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: drop-shadow(0 12px 18px rgba(31, 37, 72, .14));
}

.gs-funnel-card__placeholder {
  fill: currentColor;
  opacity: .9;
}

.gs-funnel-card__status {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
  padding: 5px 8px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  border-radius: 6px;
}

.gs-funnel-card__status.is-live {
  color: #28a866;
  background: #dff7ea;
}

.gs-funnel-card__status.is-draft {
  color: #b77a00;
  background: #fff0c9;
}

.gs-funnel-card__manage {
  position: absolute;
  inset: auto 14px 14px;
  padding: 9px 12px;
  color: #ffffff;
  font-size: 13px;
  font-weight: 650;
  text-align: center;
  background: #ff5b7f;
  border-radius: 6px;
  box-shadow: 0 12px 24px rgba(255, 91, 127, .28);
  opacity: 0;
  transform: translateY(8px);
  transition: opacity .18s ease, transform .18s ease;
}

.gs-funnel-card:hover .gs-funnel-card__manage {
  opacity: 1;
  transform: translateY(0);
}

.gs-funnel-card__body {
  display: grid;
  gap: 7px;
  padding: 14px 16px 16px;
}

.gs-funnel-card__title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.gs-funnel-card__title {
  min-height: 36px;
  margin: 0;
  color: #171b3f;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 1.28 !important;
}

.gs-funnel-card__meta {
  margin: 0;
  color: #7c849c;
  font-size: 12px;
}

.gs-funnel-card__actions {
  display: flex;
  flex-wrap: nowrap;
  gap: 6px;
  padding-top: 2px;
}

.gs-funnel-card__icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  color: #5f6884;
  background: #f7f8fc;
  border: 1px solid #e4e8f1;
  border-radius: 6px;
  transition: color .15s ease, background .15s ease, border-color .15s ease;
}

.gs-funnel-card__icon-button:hover {
  color: #ff5b7f;
  background: #fff5f7;
  border-color: #ffc4d1;
}

.gs-funnel-card__media:focus-visible,
.gs-funnel-card__icon-button:focus-visible {
  outline: 3px solid rgba(255, 91, 127, .3);
  outline-offset: -3px;
}

.gs-funnel-card__icon-button svg {
  width: 16px;
  height: 16px;
  fill: currentColor;
}
.gs-funnel-card.is-unpublished { background:#FBF4E8; border-color:#DDC7A8; }
.gs-funnel-card.is-unpublished .gs-funnel-card__media { background:linear-gradient(180deg,#F9EDDA,#FBF4E8); }
.gs-funnel-card__status.is-draft { color:#A92E28; background:#FFE0D7; border:1px solid #ECA99A; font-size:12px; font-weight:800; padding:5px 9px; }
</style>
